import axios from "axios";
import NProgress from "nprogress";
import { api } from "./helper";
const client = axios.create({
  baseURL: api,
  withCredentials: false,
});

client.interceptors.request.use((config) => {
  NProgress.start();
  return config;
});

client.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    return Promise.reject(error.response);
  }
);

function GetCategories(id, lang) {
  const params = {
    lang: lang,
    id: id,
    action: "share",
  };
  return client.get("categories.php", { params });
}

function GetDishes(id, lang) {
  const params = {
    id: id,
    lang: lang,
    action: "share",
  };
  return client.get("dishes.php", { params });
}

function VisitCount(id) {
  const params = {
    id: id,
    action: "visit",
  };
  return client.get("dishes.php", { params });
}

function GetBkg(id) {
  const params = {
    id: id,
    action: "bkg",
  };
  return client.get("dishes.php", { params });
}

function GetInfo(id) {
  const params = {
    id: id,
    action: "shareinfo",
  };
  return client.get("dishes.php", { params });
}

function CreateOrder(order) {
  order.action = "create";
  return client.post("orders.php", order);
}

function GetLocations(userid) {
  const params = {
    id: userid,
    action: "loc"
  };
  return client.get("locations.php", { params });
}

export { GetCategories, GetDishes, VisitCount, GetBkg, GetInfo, CreateOrder, GetLocations};
